import {teamListSource} from '../../demo_fixtures';

export const SEARCH_TAG = 'search';

export const useSearchResults = ({type, search}) => {
  if (type === 'team') {
    const teams = teamListSource.results
      .filter((team) => {
        if (search) {
          team.name.indexOf(search) !== -1;
        } else {
          return true;
        }
      })
      .map((team) => {
        return {
          id: team.id,
          object_id: team.id,
          name: team.name,
          html_url: team.html_url,
          content_type: 'team',
          modified_at: team.modified_at,
          metadata: null,
        };
      });
    return {
      data: {
        count: teams.length,
        next: null,
        previous: null,
        results: teams,
        num_pages: 1,
      },
    };
  }
  return {
    data: {
      count: 0,
      next: null,
      previous: null,
      results: [],
      num_pages: 1,
    },
  };
};

export const useSearchResultsState = () => {
  return {
    data: {
      count: 0,
      next: null,
      previous: null,
      results: [],
      num_pages: 1,
    },
  };
};

export const useSearchCounts = () => null;
export const useSearchCountsState = () => {
  return {
    currentData: {
      count: 0,
      next: null,
      previous: null,
      results: [],
      num_pages: 1,
    },
  };
};
